export const ContactCountBadge = ({ count }: { count: number }) => {
  if (count <= 0) {
    return null;
  }

  return (
    <span
      className="inline-flex size-5 min-w-5 items-center justify-center rounded-full bg-primary text-[10px] font-semibold leading-none text-primary-foreground"
      aria-label={String(count)}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
};
